import EmbeddedLayout from '../../layouts/EmbeddedLayout';
import DoneContent from '../shared/DoneContent';

type Props = {
  onComplete: () => Promise<void>;
  continueInApp: boolean;
  deliveryMode: 'redirect' | 'webhook';
};

export default function EmbeddedDonePage(props: Props) {
  return (
    <EmbeddedLayout>
      <DoneContent {...props} />
    </EmbeddedLayout>
  );
}
